import React from "react";
import { Link } from "react-router-dom";

const OrderFailed = ({ customerEmail }) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const message = urlParams.get('message');
    return (
        <>
            <section style={{ background: 'linear-gradient(to bottom, #feca321f, transparent)' }}>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6 text-center">
                            <img src="./assets/images/order_failed.svg" className='w-75' alt="Order failded" />
                        </div>
                        <div className="col-md-6">
                            <div className='p-3 rounded-3 bg-white border'>
                                <h2 className='mt-3'>
                                    your order has been{" "}
                                    <span className="text-danger"> Failed!</span>
                                </h2>
                                <p className="my-4 py-1 px-2 alert alert-danger">
                                    {message}
                                </p>
                                <ul>
                                    <li>We're experiencing a delay in processing your order.</li>
                                    <li>If the payment was deducted, your order should be confirmed within 30-60 minutes.</li>
                                    <li>If your order is still not processed after this time, please contact our support team at support@simfly.biz</li>
                                </ul>
                                <Link to='/destinations' className="mybtn primary-bg text-white mt-3">
                                    <i class="bi bi-shop fs-6"></i>  Back to Store
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default OrderFailed;
